import dateUtils from '@utils/DateUtils'
import sizeUtils from '@utils/sizeUtils'
import Vector from './vector'
// import

export default class VectorMbtile extends Vector {
  constructor (obj, index) {
    super(obj)
    Object.assign(this, {
      _listProperties: [],
      _isResult: obj.is_result,
      _isGeoJson: false,
      _thumbnailUrl: obj.thumbnail_url ? obj.thumbnail_url : undefined,
      _createdBy: obj.created_by ? obj.created_by : undefined,
      _createdAt: obj.created_at
        ? dateUtils.convertUTCToLocalDateV2(obj.created_at)
        : undefined,
      _path: obj.path ? obj.path : undefined,
      _srs: obj.srs ? obj.srs : undefined,
      _styleType: obj.style_type,
      _styleName: obj.style_name,
      _styleGroup: obj.style_group ? obj.style_group : undefined,
      _workspaceId: obj.workspace_id ? obj.workspace_id : undefined,
      _type: obj.type ? obj.type : undefined,
      _layer: obj.wms_name ? obj.wms_name : '',
      _bbox: obj.bbox
        ? obj.bbox
        : [
          110.61369308207,
          0.93976441214937,
          110.61656385273,
          0.94166144967178
        ],
      _displayType: obj.style ? obj.style.type : 'line',
      _originDisplayType: obj.style ? obj.style.type : undefined,
      _style: obj.style ? obj.style.paint : undefined,
      _shpPath: obj.shp_path ? obj.shp_path : [],
      _vectorType: obj.vector_type,
      _sourceLayer: obj.source_layer,
      _tileUrl: obj.tile_url,
      _size: obj.size_mb ? this.transformSize(obj.size_mb) : '0 KB',
      _sizeMb: obj.size_mb,
      _properties: obj.properties ? obj.properties : undefined,
      _typeOfVector: undefined,
      _categories: obj.categories ? obj.categories : [],
      _geometryType: obj.geometry_type,
      _area: parseInt(obj.area),
      _featureCount: obj.feature_count
    })
  }

  transformSize (size) {
    if (size !== undefined && size !== null && size !== '') {
      return sizeUtils.transfSize(size)
    } else {
      return '0 KB'
    }
  }
  get displayType () {
    return this._displayType
  }
  get styleType () {
    return this._styleType
  }
  get originDisplayType () {
    return this._originDisplayType
  }
  set displayType (newValue) {
    this._displayType = newValue
  }
  get isResult () {
    return this._isResult
  }
  get isGeoJson () {
    return this._isGeoJson
  }
  get sizeMb () {
    return this._sizeMb
  }
  get shpPath () {
    return this._shpPath
  }
  get sourceLayer () {
    return this._sourceLayer
  }
  get vectorType () {
    return this._vectorType
  }
  get tileUrl () {
    return this._tileUrl
  }
  get properties () {
    return this._properties
  }
  set properties (newValue) {
    this._properties = newValue
  }
  get size () {
    return this._size
  }
  get style () {
    return this._style
  }
  set style (newValue) {
    this._style = newValue
  }
  get bbox () {
    return this._bbox
  }
  set bbox (newValue) {
    this._bbox = newValue
  }
  get layer () {
    return this._layer
  }
  get createdBy () {
    return this._createdBy
  }
  get createdAt () {
    return this._createdAt
  }
  get path () {
    return this._path
  }
  get thumbnailUrl () {
    return this._thumbnailUrl
  }
  get srs () {
    return this._srs
  }
  get type () {
    return this._type
  }
  get workspaceId () {
    return this._workspaceId
  }
  get styleGroup () {
    return this._styleGroup
  }
  get styleName () {
    return this._styleName
  }
  set styleGroup (newValue) {
    this._styleGroup = newValue
  }
  get listProperties () {
    return this._listProperties
  }
  set listProperties (newValue) {
    this._listProperties = newValue
  }
  get typeOfVector () {
    return this._typeOfVector
  }
  set typeOfVector (newValue) {
    this._typeOfVector = newValue
  }
  get categories () {
    return this._categories
  }
  get geometryType () {
    return this._geometryType
  }
  set area (val) {
    this._area = val
  }
  get area () {
    return this._area
  }
  set featureCount (val) {
    this._featureCount = val
  }
  get featureCount () {
    return this._featureCount
  }
}



// WEBPACK FOOTER //
// ./src/models/vector/vector-mbtile.js